{
  "version": "0.2.0",
  "gitCommitHash": "713dd63102f6b3fa870a1f44c76db6122a17d065",
  "gitCommitShortHash": "713dd63",
  "gitBranch": "HEAD",
  "gitTags": "",
  "clean": true
}